import { ButtonHTMLAttributes, FC, ReactNode, useContext, useState } from 'react'
import classNames from 'classnames'
import { ActionsButton } from './ActionsButton'
import SvgPause from '../../components/icons/Pause'
import { InternalContext } from '../contexts/InternalContext'
import './ActionsSelectionButton.scss'
import { RangeEdge } from '../../enums/RangeEdge'
import { logger } from '../../logger/logger'
import { LogActionType } from 'api/logs/log-action-type'

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  play: () => Promise<void>
  edge: RangeEdge
  direction: 'after' | 'before'
  icon: ReactNode
}

export const ActionsSelectionButton: FC<Props> = ({ play, icon, className, direction, edge, ...attrs }) => {
  const { stop } = useContext(InternalContext).audioPlayer
  const [playing, setPlaying] = useState(false)

  return (
    <ActionsButton
      className={classNames('ActionsSelectionButton', className)}
      onClick={() => {
        if (playing) {
          logger.log(LogActionType.ChannelsStopButtonClick, { direction, edge })

          stop()
        } else {
          logger.log(LogActionType.ChannelsPlayButtonClick, { direction, edge })

          setPlaying(true)

          play().finally(() => setPlaying(false))
        }
      }}
      {...attrs}
    >
      {playing ? <SvgPause /> : icon}
    </ActionsButton>
  )
}
